// src/routes/admin/platform/__layout.tsx
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireAuth, requireSurface } from '@/lib/guards';
import { AdminShell } from '@/components/layouts/AdminShell';

export const Route = createFileRoute('/_staff/admin/platform')({
  beforeLoad: (ctx) => {
    requireAuth({ location: { pathname: ctx.location.pathname } });
    requireSurface('platform');
  },
  component: PlatformLayout,
  staticData: { crumb: 'Platform', surface: 'Platform Admin' },
});

function PlatformLayout() {
  return (
    <AdminShell variant="platform">
      <Outlet />
    </AdminShell>
  );
}
